export default {
    name: 'AutoLoginMyAccount',
    data: function () {
        return {
            autoLoginLoading: false,
        }
    },
    methods: {
        autoLoginToMyAccount() {
            try {
                this.autoLoginLoading = true
                const regularTraveler = window.ibJS?.application?.travelerInfos?.[0]
                const extensionTraveler = window.ibJS?.app?.travelerInfos?.[0]
                const extensionPolicy = window.ibJS?.policyDTO

                const certNumber = regularTraveler?.certNumber || extensionTraveler?.certNumber || extensionPolicy?.certificateNumber
                const birthDate = regularTraveler?.birthDate || extensionTraveler?.birthDate || extensionPolicy?.insuredPolicyPersonDTO?.birthDate

                if (!certNumber || !birthDate) {
                    throw new Error('Certificate or DOB missing!')
                }

                // API payload (Certificate reversed for anti-bot measure)
                const certReverse = certNumber.split('').reverse().join('')
                const lang = window.globalLanguage.lang || 'en'
                const payload = {
                    certNo: certNumber,
                    dob: birthDate,
                }

                const loginUrl = '/clients/login/?cntAcct=' + encodeURIComponent(certReverse) + '&lang=' + lang

                this.$http
                    .post(loginUrl, JSON.stringify(payload))
                    .then((response) => {
                        const body = response.body || response.data

                        if (body.status === 'success' && body.data?.redirectUrl) {
                            console.log('Auto-login successful, redirecting to: ', body.data.redirectUrl)
                            window.location.pathname = body.data.redirectUrl
                            return
                        }

                        if (body.status === 'error') {
                            const errorMsg = body.data?.allErrorMessages?.[0]
                            const failureErrors = ['No records found', 'DECLINED, PAYMENT', 'Declined Payment Login', 'ME_DIFF_AFFILIATE']

                            if (failureErrors.includes(errorMsg)) {
                                console.warn('Certificate validation failed: ', errorMsg)
                                this.autoLoginLoading = false
                                this.fallbackToManualLogin()
                                return
                            }

                            // Handle MyAccount unavailability
                            if (errorMsg === 'MyAccount is not available') {
                                this.autoLoginLoading = false
                                alert('MyAccount is not available for this product. Please contact support.')
                                return
                            }

                            // Other errors
                            console.error('Auto-login error: ', errorMsg)
                            this.autoLoginLoading = false
                            this.fallbackToManualLogin()
                        }
                    })
                    .catch((error) => {
                        this.autoLoginLoading = false
                        console.error('Network error during auto-login', error)
                        this.fallbackToManualLogin()
                    })
            } catch (error) {
                this.autoLoginLoading = false
                console.error(error.message)
                this.fallbackToManualLogin()
            }
        },
        fallbackToManualLogin() {
            window.location.href = '/myaccount/'
        },
    },
}
